export const CERTIFICATE_TYPE = Object.freeze({
  COMMON: "COMMON",
  GWP_CONCRETE: "GWP_CONCRETE",
  GWP_GENERAL: "GWP_GENERAL",
  TVOC: "TVOC",
});

export const CERTIFICATE_IDS_BY_TYPE = Object.freeze({
  [CERTIFICATE_TYPE.COMMON]: [1, 2],
  [CERTIFICATE_TYPE.GWP_CONCRETE]: [3, 4],
  [CERTIFICATE_TYPE.GWP_GENERAL]: [5, 6],
  [CERTIFICATE_TYPE.TVOC]: [7, 8],
});